// extracted by mini-css-extract-plugin
export default {"file":"File_file__+LliM","fileIcon":"File_fileIcon__DEOPM","fileName":"File_fileName__IfpFf","download":"File_download__ld6YX"};